import React from 'react';
import IGWelcomerSlideoutBannerNormalSrc from './IGWelcomerSlideoutBanner_normal.png';
import IGWelcomerSlideoutBannerWhiteSrc from './IGWelcomerSlideoutBanner_white.png';

export const IGWelcomerSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={IGWelcomerSlideoutBannerWhiteSrc} />
  ) : (
    <img src={IGWelcomerSlideoutBannerNormalSrc} />
  );
};
